import { useNavigate } from "react-router-dom";
import "./App.css";
import React from "react";

export const App = () => {
  const nav = useNavigate();
  return (
    <div>
      <h4>Relocation Agent Network - Property Data visualisation</h4>
      <span className="mr-1 link" onClick={() => nav("/loop")}>
        Loop
      </span>
      <span className="mr-1 link" onClick={() => nav("/reapit/ddm")}>
        ReapIT - DDM
      </span>
      <span className="link" onClick={() => nav("/reapit/qac")}>
        ReapIT - QAC
      </span>
    </div>
  );
};

export default App;
